import React from 'react';
import PropTypes from 'prop-types';

export default class IntroSection extends React.PureComponent {
    static propTypes = {
        launchedCountries: PropTypes.object,
        unavailableCountries: PropTypes.object,
        introContent: PropTypes.object,
        country: PropTypes.string,
        isLoggedIn: PropTypes.bool,
        isSubscribed: PropTypes.bool
    };

    getCTA() {
        let fromLiveCountries = false;
        let liveCountry = [];
        const {introContent} = this.props;

        for (const countryInfo of this.props.launchedCountries.countryLaunchedInfo) {
            if (countryInfo.countryCode === this.props.country) {
                fromLiveCountries = true;
                liveCountry = countryInfo;
            }
        }

        let fromUnavailableCountries = false;
        for (const code of this.props.unavailableCountries.countryCode) {
            if (code === this.props.country) {
                fromUnavailableCountries = true;
            }
        }

        const showRegularCTA = !fromLiveCountries && !fromUnavailableCountries;
        let ctaSection = null;
        if (showRegularCTA) {
            if (!this.props.isLoggedIn || !this.props.isSubscribed) {
                if (introContent.enablePreRegister) {
                    ctaSection = (
                        <div className="btn-container">
                            <div className="hexagon" />
                            <div className="cta-buttons text-center">
                                <h2>Download Now</h2>
                                <a id="google-store-link" href={introContent.androidLink} target="_blank" rel="noopener noreferrer">
                                    <img src={introContent.androidCTA} alt="Android Link" />
                                </a>
                                <a id="sign-up-btn" href={`${introContent.register}`}>
                                    <img src={introContent.pcCTA} alt="PC Link" />
                                </a>
                                <h2 className="white">Free To Play</h2>
                            </div>
                            <div className="pre-register-gift">
                                <a href={introContent.preRegisterLink}>
                                    <img src={introContent.preRegisterImg} alt="preregister" />
                                </a>
                            </div>
                        </div>
                    );
                } else {
                    ctaSection = (
                        <div className="cta-buttons">
                            <a id="google-store-link" href={introContent.androidLink} target="_blank" rel="noopener noreferrer">
                                <img src={introContent.androidCTA} alt="Android Link" />
                            </a>
                            <a id="sign-up-btn" href={`${introContent.register}`}>
                                <img src={introContent.pcCTA} alt="PC Link" />
                            </a>
                        </div>
                    );
                }
            } else {
                ctaSection = (
                    <div className="cta-buttons">
                        <a id="google-store-link" href={introContent.androidLink} target="_blank" rel="noopener noreferrer">
                            <img src={introContent.androidCTA} alt="Android Link" />
                        </a>
                    </div>
                );
            }
        } else if (fromLiveCountries && !fromUnavailableCountries) {
            ctaSection = (
                <div>
                    <div id="download-from-store" className="placeholder" />
                    <div className="download-from-store">
                        <a id="ios-download" href={liveCountry.iosLink} target="_blank" rel="noopener noreferrer">
                            <img src={this.props.launchedCountries.appStoreImg} alt="Apple Store" />
                        </a>
                        <a id="android-download" href={liveCountry.androidLink} target="_blank" rel="noopener noreferrer">
                            <img src={this.props.launchedCountries.googlePlayImg} alt="Google Play" />
                        </a>
                    </div>
                </div>
            );
        } else if (fromUnavailableCountries) {
            ctaSection = (
                <div className="country-unavailable">
                    <h3>{this.props.unavailableCountries.message}</h3>
                </div>
            );
        } else {
            console.warn('Unable to process CTASection due to fail to match conditions');
        }

        return ctaSection;
    }
    render() {
        const ctaSection = this.getCTA();

        return (
            <div className="introSection">
                <div className="dragon" />
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <h1>EPIC BOSS BATTLES</h1>
                        </div>
                    </div>
                </div>
                {ctaSection}
            </div>
        );
    }
}
